<template>
  <div class="container">
    <!--找回密码-->
    <div class="dengl">
      <div class="dly">
        <div class="dlyt fl"><img src="@/view/images/y75.jpg"></div>
        <div class="dlyw fr">
          <div class="dlywa">
            <h6>找回密码</h6>
            <p class="loginbtn"><a href="javascript:void(0);" @click="login">返回登录</a></p>
          </div>
          <div class="zhaoha">
            <div class="dlywb_a">
              <p>手机号</p>
              <input class="input1" type="text" v-model.number="mobile" value="请输入您的手机号" onfocus="if(value=='请输入您的手机号') {value=''}" onblur="if (value=='') {value='请输入您的手机号'}">
            </div>
            <div class="dlywb_a">
              <p>验证码</p>
              <div class="zhaoha_a">
                <input class="input1" type="text" v-model="code" value="请输入手机验证码" onfocus="if(value=='请输入手机验证码') {value=''}" onblur="if (value=='') {value='请输入手机验证码'}">
                <span><a href="#">获取验证码</a></span>
              </div>
            </div>
            <div class="dlywb_a">
              <p>设置密码</p>
              <input class="input1" type="text" v-model="password1" value="请输入密码" onfocus="if(value=='请输入密码') {value=''}" onblur="if (value=='') {value='请输入密码'}">
            </div>
            <div class="dlywb_a">
              <p>再次输入密码</p>
              <input class="input1" type="text" v-model="password2" value="请输入密码" onfocus="if(value=='请输入密码') {value=''}" onblur="if (value=='') {value='请输入密码'}">
            </div>
            <div class="dlywb_b">
              <input type="submit" value="重置密码" @click="resetsuccess">
            </div>
          </div>
        </div>
      </div>
      <div class="yjd">
        <p>Copyright©  2019-2021   印工社（青岛）数字科技有限公司  All Rights Reserved<span>|</span><a
            href="https://beian.miit.gov.cn"
            target="_banck"
            style="corsor:pointer"
          >
            鲁ICP备20000134号-3</a
          ><span></span><a href="https://beian.mps.gov.cn/#/query/webSearch?code=37021402002207\" target="_banck">鲁公网安备 37021402002207号</a><span class="span1">|</span>网站建设：<a href="#">印工社</a></p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'forgetName',
  data() {
    return {
      mobile: '请输入您的手机号',
      password1: '请输入您的密码',
      password2: '请输入您的密码',
      code: '请输入验证码',
    };
  },
  methods: {
    init() {

    },
    privacy() {
      this.$router.push({ path: '/privacy' });
    },
    register() {
      this.$router.push({ path: '/register' });
    },
    resetsuccess() {
      this.$router.push({ path: '/resetsuccess' });
    },
    login() {
      this.$router.push({ path: '/login' });
    },
  },
  mounted() {

  },
  created() {
    this.init();
  },
};
</script>

<style scoped>
  .container{
    background-color: #273142;
    width: 100%;
    height: 100vh;
  }
  .dengl .yjd{
    margin-top: 15px;
  }
  /*.dlywa{*/
    /*position: relative;*/
  /*}*/
  /*.loginbtn{*/
    /*width: auto;*/
    /*position: absolute;*/
    /*right: 0;*/
    /*top: 50%;*/
    /*transform: translateY(-50%);*/
    /*z-index: 99;*/
    /*margin-top: 0 !important;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/view/forget.vue